import { z } from "zod";

import { ProcessStatusTableDtoSchema } from "../../../dtos/processes";

export const GetProcessesResponseBodySchema = z.object({
  processes: ProcessStatusTableDtoSchema.array(),
});

export type GetProcessesResponseBodyType = z.infer<
  typeof GetProcessesResponseBodySchema
>;
